module.exports = __webpack_public_path__ + "images/icon-152.58f42288ba1fb971b359711a114cce81.png";